export default __webpack_public_path__ + "static/media/travel-time-overlay.68951c40.svg";